import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import ProjectPage from '../../components/ProjectPage'

const projectElements = {
	images: [
	  {
	    "src": "Routine/1",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Routine/2",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Routine/3",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Routine/4",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Routine/5",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Routine/6",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Routine/7",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Routine/8",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Routine/9",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Routine/10",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Routine/11",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Routine/12",
	    "orientation": "landscape"
	  },
	  	  {
	    "src": "Routine/13",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Routine/14",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Routine/15",
	    "orientation": "landscape"
	  }
	]
}

export default class Paper extends React.Component{
	render(){
		return(
			<ProjectPage 
			title="Routine des Lebens" 
			text={`Für ein Monat habe ich meine tägliche Routine etwas verändert. Ich hab mir vorgenommen jeden Tag nach dem Aufstehen und vor dem Schlafen gehen ein Foto zu machen. Anfangs hat das ganz gut funktioniert, aber nach ein paar Tagen habe ich bereits eine tägliche Erinnerung gebraucht. Aus diesem kleinen Experiment habe ich gelernt, dass es mehr als nur ein Monat braucht um neue Gewohnheiten und Routinen zu entwicklen.`} 
			images={projectElements.images}/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/pages/projects/routine.js